import React from 'react';
import './AboutPage.css';

const AboutPage = () => {

  return (
    <div className="about-page">
      <div className="about-hero">
        <div className="container">
          <h1 className="about-hero-title">Bulut Ambalaj Hakkında</h1>
          <p className="about-hero-subtitle">
            Kaliteli ve çevre dostu karton bardak üretiminde öncü firma
          </p>
        </div>
      </div>

      <div className="about-content">
        <div className="container">
          <section className="about-section">
            <div className="section-container">
              <h2 className="section-title">Hikayemiz</h2>
              <div className="section-content">
                <p>
                  Bulut Ambalaj olarak, karton bardak üretim sektöründe yılların verdiği deneyim ve 
                  bilgi birikimiyle hizmet vermekteyiz. İstanbul'da bulunan modern tesislerimizde, 
                  en son teknoloji ile donatılmış makinelerimizle kaliteli üretim yapmaktayız.
                </p>
                <p>
                  Karton bardak üretiminin yanı sıra pizza kutusu, pide kutusu ve isteğe göre koli 
                  üretimi de yapmaktayız. Geniş ürün yelpazemiz ile işletmenizin tüm ambalaj 
                  ihtiyaçlarını karşılıyoruz.
                </p>
                <p>
                  Müşteri memnuniyetini ön planda tutan anlayışımızla, sektörde güvenilir bir marka 
                  haline geldik. Küçük işletmelerden büyük zincirlere kadar geniş bir müşteri 
                  portföyüne sahibiz ve her bir müşterimize özel çözümler sunmaktayız.
                </p>
              </div>
            </div>
          </section>

          <section className="about-section">
            <div className="mission-vision-container">
              <div className="mission-vision-item">
                <h2 className="section-title">Misyonumuz</h2>
                <div className="section-content">
                  <p>
                    Misyonumuz, çevre dostu ve kaliteli ambalaj çözümleri sunarak işletmelerin 
                    ihtiyaçlarını karşılamak ve sürdürülebilir bir gelecek için katkıda bulunmaktır. 
                    Üretim süreçlerimizde çevreye duyarlı malzemeler kullanarak, doğaya saygılı 
                    bir üretim anlayışı benimsiyoruz.
                  </p>
                  <p>
                    Müşterilerimize en kaliteli ürünleri, en uygun fiyatlarla ve en hızlı şekilde 
                    ulaştırmak temel hedefimizdir. Bu doğrultuda sürekli kendimizi geliştiriyor, 
                    teknolojiye yatırım yapıyor ve müşteri memnuniyetini artırmak için çalışıyoruz.
                  </p>
                </div>
              </div>
              <div className="mission-vision-item">
                <h2 className="section-title">Vizyonumuz</h2>
                <div className="section-content">
                  <p>
                    Vizyonumuz, Türkiye'nin önde gelen karton bardak üreticilerinden biri olmak ve 
                    uluslararası pazarlarda da yer almak. Sektörde yenilikçi çözümler sunarak, 
                    müşterilerimize değer katmak ve sürdürülebilir büyüme sağlamak.
                  </p>
                  <p>
                    Gelecekte daha geniş bir ürün yelpazesi sunarak, ambalaj sektöründe kapsamlı 
                    bir çözüm ortağı olmayı hedefliyoruz. Ar-Ge çalışmalarımıza devam ederek, 
                    çevre dostu ve yenilikçi ürünler geliştirmeye odaklanıyoruz.
                  </p>
                </div>
              </div>
            </div>
          </section>

          <section className="about-section">
            <div className="section-container">
              <h2 className="section-title">Değerlerimiz</h2>
              <div className="values-grid">
              <div className="value-card">
                <h3>Kalite</h3>
                <p>
                  Üretim süreçlerimizde en yüksek kalite standartlarını uyguluyor, 
                  her ürünümüzü titizlikle kontrol ediyoruz.
                </p>
              </div>
              <div className="value-card">
                <h3>Güvenilirlik</h3>
                <p>
                  Müşterilerimize verdiğimiz sözleri tutuyor, zamanında teslimat 
                  ve kaliteli hizmet sunuyoruz.
                </p>
              </div>
              <div className="value-card">
                <h3>Çevre Bilinci</h3>
                <p>
                  Sürdürülebilir üretim yöntemleri kullanarak, çevreye duyarlı 
                  ürünler üretiyoruz.
                </p>
              </div>
              <div className="value-card">
                <h3>Müşteri Odaklılık</h3>
                <p>
                  Müşterilerimizin ihtiyaçlarını anlayarak, onlara özel çözümler 
                  geliştiriyoruz.
                </p>
              </div>
              <div className="value-card">
                <h3>Yenilikçilik</h3>
                <p>
                  Sektördeki gelişmeleri takip ederek, yenilikçi ürün ve hizmetler 
                  sunuyoruz.
                </p>
              </div>
              <div className="value-card">
                <h3>Uygun Fiyat</h3>
                <p>
                  Kaliteli ürünleri, rekabetçi fiyatlarla müşterilerimize 
                  sunuyoruz.
                </p>
              </div>
              </div>
            </div>
          </section>

          <section className="about-section">
            <div className="section-container">
              <h2 className="section-title">Üretim Sürecimiz</h2>
              <div className="section-content">
                <p>
                  Modern tesislerimizde, en son teknoloji ile donatılmış makinelerimizle üretim 
                  yapmaktayız. Üretim sürecimiz, hammadde seçiminden son kontrole kadar her aşamada 
                  kalite kontrolünden geçmektedir.
                </p>
              </div>
              <div className="process-steps">
                <div className="process-step">
                  <div className="step-number">1</div>
                  <h3>Hammadde Seçimi</h3>
                  <p>
                    Çevre dostu ve kaliteli hammaddeler seçilerek, üretim sürecine başlanır.
                  </p>
                </div>
                <div className="process-step">
                  <div className="step-number">2</div>
                  <h3>Üretim</h3>
                  <p>
                    Modern makinelerimizle, hijyenik koşullarda üretim gerçekleştirilir.
                  </p>
                </div>
                <div className="process-step">
                  <div className="step-number">3</div>
                  <h3>Kalite Kontrol</h3>
                  <p>
                    Her ürün, kalite kontrol ekibimiz tarafından titizlikle kontrol edilir.
                  </p>
                </div>
                <div className="process-step">
                  <div className="step-number">4</div>
                  <h3>Depolama</h3>
                  <p>
                    Üretilen ürünler, hijyenik koşullarda depolanarak korunur.
                  </p>
                </div>
                <div className="process-step">
                  <div className="step-number">5</div>
                  <h3>Ambalajlama</h3>
                  <p>
                    Ürünler, güvenli ve hijyenik şekilde ambalajlanarak hazır hale getirilir.
                  </p>
                </div>
                <div className="process-step">
                  <div className="step-number">6</div>
                  <h3>Teslimat</h3>
                  <p>
                    Müşterilerimize zamanında ve güvenli şekilde teslimat yapılır.
                  </p>
                </div>
              </div>
            </div>
          </section>

          <section className="about-section">
            <div className="section-container">
              <h2 className="section-title">Neden Bizi Seçmelisiniz?</h2>
              <div className="why-choose-grid">
              <div className="why-choose-card">
                <h3>Geniş Ürün Yelpazesi</h3>
                <p>
                  Farklı boyut ve tasarım seçenekleriyle ihtiyacınıza uygun ürünler sunuyoruz.
                </p>
              </div>
              <div className="why-choose-card">
                <h3>Özel Tasarım</h3>
                <p>
                  Markanıza özel tasarım ve baskı seçenekleriyle fark yaratmanıza yardımcı oluyoruz.
                </p>
              </div>
              <div className="why-choose-card">
                <h3>Hızlı Teslimat</h3>
                <p>
                  Geniş üretim kapasitemiz sayesinde, siparişlerinizi hızlıca teslim ediyoruz.
                </p>
              </div>
              <div className="why-choose-card">
                <h3>Uygun Fiyat</h3>
                <p>
                  Kaliteli ürünleri, rekabetçi fiyatlarla sunuyoruz.
                </p>
              </div>
              <div className="why-choose-card">
                <h3>Müşteri Desteği</h3>
                <p>
                  7/24 müşteri desteği ile yanınızdayız.
                </p>
              </div>
              <div className="why-choose-card">
                <h3>Çevre Dostu</h3>
                <p>
                  Sürdürülebilir ve çevre dostu ürünler üretiyoruz.
                </p>
              </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;
